import React from 'react';
import { useChristmasTheme } from './ChristmasThemeContext';

const Snowflakes = () => {
  const { isChristmasTheme } = useChristmasTheme();

  if (!isChristmasTheme) return null;

  // Array of different snowflake characters for variety
  const snowflakeChars = ['❄', '❅', '❆', '✻', '✼', '❉', '❋', '❄', '❅', '❆'];

  return (
    <div className="snowflakes" aria-hidden="true">
      {snowflakeChars.map((char, index) => (
        <span key={index} className="snowflake">
          {char}
        </span>
      ))}
    </div>
  );
};

export default Snowflakes;

